import { useLang } from '@/app/utils/useLang';
import CommonProducts from '../components/common-products';

const SmartGeneration: React.FC = () => {
    const { t } = useLang('landingPage.smart_generation');

    const items = [
        {
            img: '',
            label: t('item2_title'),
            productId: '7287920001178',
            variantId: '42092770263194',
            learnMore: 'https://ca.ecoflow.com/products/400w-portable-solar-panel?variant=42092770263194',
        },
        {
            img: '',
            label: t('item3_title'),
            productId: '8066689826970',
            variantId: '62891218796915',
            learnMore: 'https://ca.ecoflow.com/products/ecoflow-nextgen-220w-portable-solar-panel?variant=62891218796915',
        },
    ];

    return <CommonProducts items={items} title={t('title')} />;
};

export default SmartGeneration;
